<template>
  <Dialog class="mobile rule-dialog" :modelValue="props.modelValue" @update:modelValue="updateModelValue" type="common" :showClose="true">
    <div class="rule-dialog-content">
      <!-- todo -->
      <div class="text-item" v-for="text in ruleTexts" :key="text">
        <span v-html="text"></span>
      </div>
    </div>
  </Dialog>
</template>

<script setup>
/* eslint-disable */
import Dialog from '@/components/Dialog/ActMwr/index.vue'
import { defineProps, defineEmits, computed } from 'vue'
import { useI18n } from 'vue-i18n'
const { t } = useI18n()
const emit = defineEmits(['update:modelValue'])

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false
  }
})

const ruleTexts = computed(() => {
  let text = t('mwr.dragon.rule')
  text = text.replaceAll('\n\n', '<br /><br />\n')
  console.log(text)

  const texts = text.split('\n')
  console.log(texts)
  return texts
})

const updateModelValue = (value) => {
  emit('update:modelValue', value)
}
</script>

<style lang="less" scoped src="./mobile_style.less"></style>
